<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">      
        <b-col md="8">           
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <form @submit.prevent="onSubmit">
                    <h2 class="text-dark">Thank you for Registering</h2>
                    <p class="text-muted">You should receive a confirmation email shortly with your username and password reminder. <br><br>
                    Before you can be given access to the system we need to verify your registration, which can take up to 24 hours to process. A notification email will be sent to you once this has been completed.<br><br>
If you need assistance, please email DLT Team at dcyemen@un.org </p>
                    <b-row>
                      <b-col>
                          <b-button variant="primary" @click="closePage" class="primary mt-3">Close</b-button>
                      </b-col>
                  </b-row>
                    
                </form>
              </b-card-body>
            </b-card>            
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types'
import axios from 'axios'

export default {
  name: 'Login',
  data () {
      return {
        username: '',
        password: ''
      }
  },    
  methods: {

    closePage() {

      // redirect to login
      this.$router.push('/login')
    },

    onSubmit () {        
        this.$store.dispatch(types.ACTION_AUTH_USER, {username: this.username, password: this.password})
    }
  },
  mounted() {
    // console.log("DECON_API: "+ process.env.DECON_API)
  },

  created() {       
     
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/RegisterSuccess.vue